import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { Collection } from "@/components/Collection";
import { Services } from "@/components/Services";
import { ProductDrawer } from "@/components/ProductDrawer";
import { Intro } from "@/components/Intro";
import { ContactSection } from "@/components/Contact";
import { scrollToId } from "@/lib/api";

const seen = typeof window !== "undefined" && sessionStorage.getItem("rwiha_intro") === "1";

export default function Home() {
  const [intro, setIntro] = useState(!seen);
  const [product, setProduct] = useState(null);
  const { hash } = useLocation();

  useEffect(() => {
    sessionStorage.setItem("rwiha_intro", "1");
  }, []);

  useEffect(() => {
    if (!hash) return undefined;
    const t = setTimeout(() => scrollToId(hash.slice(1)), 400);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <main data-testid="home-page">
      {intro && <Intro onDone={() => setIntro(false)} />}
      <Hero introDelay={seen ? 0.3 : 1.9} />
      <Marquee />
      <Manifesto />
      <Collection onOpen={setProduct} />
      <Services />
      <ContactSection />
      <ProductDrawer product={product} onClose={() => setProduct(null)} />
    </main>
  );
}
